/**
 * Espelha o enum numérico `APIEnum` do backend (integrações / identificador de API).
 * Descrições amigáveis (`EnumDescription` no C#) podem ser mapeadas à parte, se necessário.
 */

export enum EIntegracoesAPIEnum {
  None = 0,
  Boticario = 1,
  Zanthus = 2,
  NFe = 3,
  /** Stone (Antigo) */
  Stone = 4,
  NFSe = 5,
  MicrovixPadrao = 6,
  SAT = 7,
  Ecletica = 8,
  FXData = 9,
  /** Stone (Novo) */
  StonePadraoF360 = 10,
  TOTVSChef = 11,
  MoozCartoes = 12,
  MercadoPago = 13,
  PDVLoop = 14,
  /** Pluxee / Sodexo */
  Sodexo = 100,
  Ticket = 101,
  VR = 102,
  Cielo = 103,
  /** Linx Degust V1 */
  LinxDegust = 104,
  LinxErpFranquias = 105,
  /** Linked Gourmet */
  LinkedGourmet = 106,
  /** PDV FollowUp */
  PDVFollowUp = 107,
  /** PDV UPDI */
  PDVUPDI = 108,
  /** PDV Net */
  PdvNet = 109,
  CieloAPI = 110,
  /** PDV Bling */
  PdvBling = 111,
  /** Wirecard */
  WirecardAPI = 112,
  /** PDV Colibri */
  PdvColibri = 113,
  /** Adiq */
  OperadoraAdiq = 114,
  /** Pdv Next Soft */
  NextSoft = 115,
  /** Pagar Me */
  PagarMe = 116,
  /** Pdv Nexaas OMS */
  PdvNexaasEstoka = 117,
  /** Pdv Gilbarco */
  PdvGilbarco = 118,
  /** IFood */
  IFood = 119,
  /** PDV Avec */
  PdvAvec = 120,
  /** MVarandas */
  Mvarandas = 121,
  /** Gestão Click */
  GestaoClick = 122,
  /** Vindi */
  Vindi = 123,
  /** PDV Vtex */
  PdvVtex = 124,
  /** InfinitePay */
  InfinitePay = 125,
  /** Rede */
  Rede = 126,
  /** PDV Unika */
  Unika = 127,
  /** PDV Unika Oakberry */
  PdvUnikaOakberry = 128,
  /** PDV Legal */
  PDVLegal = 129,
  /** PDV Data System */
  PDVDataSystem = 130,
  /** PDV Mitryus */
  PdvMitryus = 131,
  /** FitCard */
  FitCard = 132,
  /** Pdv Sponte */
  PdvSponte = 133,
  /** Pdv Profig */
  PdvProfig = 134,
  /** Pdv Accon Nemo */
  PdvAcconNemo = 135,
  /** Pdv CPlug */
  PdvCPlug = 136,
  /** CADIS */
  CADIS = 137,
  /** Pdv Tiny */
  PdvTiny = 138,
  /** Pdv Omie */
  PdvOmie = 139,
  /** Pagar Me - Track & Field */
  PagarMe_TrackAndField = 140,
  /** Pdv Terasoft */
  PdvTerasoft = 141,
  /** Pdv Varejo Online */
  VarejoOnline = 142,
  /** API Pública da F360 */
  F360_public_api = 150,
  /** Pdv Cake */
  PdvCake = 151,
  /** Pdv OXPI */
  PdvOXPI = 152,
  /** Tray */
  Tray = 153,
  /** EComanda */
  EComanda = 154,
  /** Pagar Me - Sem Split */
  PagarMe_SemSplit = 155,
  /** Softcred */
  Softcred = 156,
  /** PagHiper */
  PagHiper = 157,
  Olist = 158,
  /** Linx Degust V2 */
  LinxDegustV2 = 159,
  /** Ame Digital */
  AmeDigital = 160,
  /** Pdv Business Shop */
  BusinessShop = 161,
  /** Pdv Varejo Fácil */
  VarejoFacil = 162,
  /** Pdv Alloc */
  PdvAlloc = 163,
  /** Pdv Roverpix */
  PdvRoverpix = 164,
  /** Adquirente Delivery Direto */
  AdquirenteDeliveryDireto = 165,
  /** Api - IFood */
  ApiRestIFood = 166,
  /** Api - SystemFarma */
  ApiSystemFarma = 167,
  /** Webhook - Paymee */
  Paymee = 168,
  /** Api - SumUp */
  SumUpApi = 169,
  /** Pdv Lupo */
  PdvLupo = 170,
  /** Api - CRM Bônus */
  CRMBonus = 171,
  /** Api - Pdv Consoft */
  ApiPdvConsoft = 172,
  /** Pdv Ammo */
  PdvAmmo = 173,
  /** Api - Alterdata */
  Alterdata = 174,
  /** Api - C6 Pay */
  ApiC6Pay = 175,
  /** Api - Pdv Colibri (Novo) */
  ApiPdvColibriNovo = 176,
  /** Api - CMV - Business Shop */
  BusinessShopCMV = 177,
  /** Api - Pdv WebPic */
  WebPic = 178,
  /** Api - Valorem Pay */
  ApiValoremPay = 179,
  /** Api - Pdv Gcom */
  ApiPdvGcom = 180,
  /** Pdv Moncloa */
  PdvMoncloa = 181,
  /** Api - Pdv Ladfood */
  ApiPdvLadfood = 182,
  /** Webhook F360 - PDV */
  WebhookF360_Pdv = 183,
  /** Api - Blu */
  ApiBlu = 184,
  /** Api - PagSeguro Accesstage */
  ApiPagSeguroAccesstage = 185,
  /** Api - TagPlus */
  ApiTagPlus = 186,
  /** Api - Pdv ClJoias */
  ApiPdvClJoias = 187,
  /** Api - Pagaleve */
  ApiPagaleve = 188,
  /** Linx Degust V3 */
  LinxDegustV3 = 189,
  /** Api - Adyen */
  ApiAdyen = 190,
  /** Api - EVO */
  ApiEVO = 191,
  /** Pagar Me V5 */
  PagarMeV5 = 192,
  /** Api - Cigam */
  ApiCigam = 193,
  /** Api - Ciss Live */
  ApiCissLive = 194,
  /** Api - ValoriBank */
  ValoriBankApi = 195,
  /** Api - VarejoFacilNFe */
  ApiVarejoFacilNFe = 196,
  /** Api - VelocePOS */
  ApiVelocePOS = 197,
  /** Api - CarMob */
  ApiCarMob = 198,
  /** Api - Devolução - BusinessShop */
  DevolucaoBusinessShop = 199,
  /** Api - Cads */
  ApiCads = 200,
  /** Api - Asaas */
  ApiAsaas = 201,
  /** Api - Pdv Trier */
  ApiPdvTrier = 202,
  /** Api - Pluggy */
  ApiPluggy = 203,
  /** Api - Pdv Clínica nas Nuvens */
  ApiPdvClinicaNasNuvens = 204,
  /** Api - Pdv Sagas */
  ApiPdvSagas = 205,
  /** Api - Pdv OPDV */
  ApiPdvOpdv = 206,
  /** Api - MultiCrediario */
  ApiMultiCrediario = 207,
  /** Api - Pdv POS Controle */
  ApiPdvPOSControle = 208,
  /** Api - Pdv Autcom */
  ApiPdvAutcom = 209,
  /** Api - Pdv Trinks */
  ApiPdvTrinks = 210,
  /** Api - Pdv Saurus */
  ApiPdvSaurus = 211,
  /** Webhook F360 - Titulos */
  WebhookF360_Titulos = 212,
  /** Api - Pdv Acert */
  ApiPdvAcert = 213,
  /** Api - Pdv Quark */
  ApiPdvQuark = 214,
  /** Api - Pdv Siso */
  ApiPdvSiso = 215,
  /** Api - Pdv Sigecloud */
  ApiPdvSigecloud = 216,
  /** Api - Pdv VipSystem */
  ApiPdvVipSystem = 217,
  /** Api - Sieg NFe */
  ApiSiegNfe = 218,
  /** Api - GalaxyPay */
  ApiGalaxyPay = 219,
  /** Api - Software Boss */
  ApiSoftwareBoss = 220,
  /** Api - Pdv Awise */
  ApiPdvAwise = 221,
  /** Api - Pdv Infosky */
  ApiPdvInfosky = 222,
  /** Api - Pdv Wps */
  ApiPdvWps = 223,
  /** Api - Addi */
  ApiAddi = 224,
  /** Webhook - Creditcorp */
  WebhookCreditcorp = 225,
  /** Api - Pdv Eyemobile */
  ApiPdvEyemobile = 226,
  /** Api - Pdv PdvPockttchef */
  PdvPockttchef = 227,
  /** Api - Adquirente ValidaPix */
  ApiOperadoraValidaPix = 228,
  /** Api - PDV Mogo Snack */
  ApiMogoSnack = 229,
  /** Api - PDV SuporTI ERP */
  ApiSuporTiErp = 230,
  /** API - Marvin */
  ApiMarvin = 231,
  /** API - PDV Cardapio Web */
  ApiPdvCardapioWeb = 232,
  /** API - PDV Microbit */
  ApiPdvMicrobit = 233,
  /** API - PDV Linx Empório */
  ApiPdvLinxEmporio = 234,
  /** API - PDV ERP BSeller */
  ApiPdvErpBSeller = 235,
  /** API - PDV Prisma */
  ApiPdvPrisma = 236,
  /** API - PagueVeloz */
  ApiPagueVeloz = 237,
  /** SQL - PDV Azul Sistemas */
  SqlPdvAzulSistemas = 238,
  /** API - Adquirente Justa */
  ApiJusta = 239,
  /** SQL - PDV Bemp */
  PdvBempSql = 240,
  /** API - PDV Nimbus */
  ApiPdvNimbus = 241,
  /** API - PDV Plainness */
  ApiPdvPlainness = 242,
  /** Pdv Varejo Online - Aceita Token */
  PdvVarejoOnlineAceitaToken = 243,
  /** API - PDV Zeus */
  ApiPdvZeus = 244,
  /** SQL - PDV Nano */
  SqlPdvNano = 245,
  /** Api - PDV Clinicorp */
  APIPdvClinicorp = 246,
  /** Api - PDV Dynaset */
  APIPdvDynaset = 247,
  /** Api - PDV Almode */
  APIPdvAlmode = 248,
  /** Api - PDV AutoPet */
  APIPdvAutoPet = 249,
  /** Api - PDV Bling V3 */
  ApiPdvBlingV3 = 250,
  /** Api - PDV Loja Integrada */
  ApiLojaIntegrada = 251,
  /** Api - PDV Inov */
  ApiInov = 252,
  /** Api - PDV Saurus V2 */
  ApiPdvSaurusV2 = 253,
  /** Api - Adquirente BankPay */
  ApiAdquirenteBankPay = 254,
  /** Api - Adquirente Monedd */
  AdquirenteMonedd = 255,
  /** Api - Pdv Wizos */
  ApiPdvWizos = 256,
  /** Api - PDV Followup Gester */
  ApiPdvFollowupGester = 257,
  /** API - Adquirente Pinbank */
  ApiAdquirentePinbank = 258,
  /** API - PDV Epoc */
  ApiPdvEpoc = 259,
  /** API - PDV Zamp */
  ApiPdvZamp = 260,
  /** API - Frogpay */
  ApiFrogpay = 261,
  /** API - PDV Feegow */
  ApiFeegow = 262,
  /** API - PDV Linx Microvix Antecipações */
  ApiPdvLinxMicrovixAntecipacoes = 263,
  /** BMG */
  BMG = 264,
  /** IFood V3 */
  IFoodV3 = 265,
  /** API - PDV EVUP */
  ApiPdvEvup = 266,
  /** Api - CMV - Data System */
  DataSystemCMV = 267,
  /** Api - VarejoFacilNFe V2 */
  ApiVarejoFacilNFeV2 = 268,
  /** Api - PDV ControleCelular */
  ApiPdvControleCelular = 269,
  /** PDV Controller Plus */
  SqlPdvControllerPlus = 270,
  /** API PDV Presence */
  ApiPdvPresence = 271,
  /** API PDV Saipos */
  ApiPdvSaipos = 272,
  /** API Adquirente PayGo */
  ApiAdquirentePayGo = 273,
  /** API Adquirente Infopago */
  ApiInfopago = 274,
  /** API PDV SaasTec */
  ApiPdvSaasTec = 275,
  /** API PDV 3S Checkout */
  ApiPdv3SCheckout = 276,
  /** Api - CMV - Linx */
  LinxCMV = 277,
  /** API - PDV Myrp */
  ApiPdvMyrp = 278,
  /** API - PDV Tecnofit */
  ApiPdvTecnofit = 282,
  /** Api - CMV - Cigam */
  ApiCigamCMV = 283,
  /** API - PDV SWFast */
  ApiPdvSWFast = 284
}

export enum EIntegracoesAcoesVR {
  VR = EIntegracoesAPIEnum.VR,
  ApiIFood = EIntegracoesAPIEnum.IFood,
  ApiSystemFarma = EIntegracoesAPIEnum.ApiSystemFarma,
  SumUpApi = EIntegracoesAPIEnum.SumUpApi,
  CRMBonus = EIntegracoesAPIEnum.CRMBonus,
  ApiBlu = EIntegracoesAPIEnum.ApiBlu,
  Rede = EIntegracoesAPIEnum.Rede,
  ApiJusta = EIntegracoesAPIEnum.ApiJusta,
  ApiAdquirenteBankPay = EIntegracoesAPIEnum.ApiAdquirenteBankPay
}

export enum ETipoArquivoMoozCartoes {
  Ambos = 0,
  Venda = 1,
  Pagamento = 2
}

export const TipoArquivoMoozCartoesOpt = [
  { label: "Ambos", value: ETipoArquivoMoozCartoes.Ambos.toString() },
  { label: "Venda", value: ETipoArquivoMoozCartoes.Venda.toString() },
  { label: "Pagamento", value: ETipoArquivoMoozCartoes.Pagamento.toString() }
];

export enum ETipoDePesquisaPagHiper {
  None = 0,
  Criados = 1,
  Pagos = 2
}

export enum ETipoDePesquisaCadis {
  None = 0,
  NFe = 1,
  NFSe = 2,
  Cupom = 3,
  OutrasDespesas = 4
}

export const TipoDePesquisaCadisOpt = [
  { label: "Ambos", value: ETipoArquivoMoozCartoes.Ambos.toString() },
  { label: "NFe", value: ETipoDePesquisaCadis.NFe.toString() },
  { label: "NFSe", value: ETipoDePesquisaCadis.NFSe.toString() },
  { label: "Cupom", value: ETipoDePesquisaCadis.Cupom.toString() },
  {
    label: "OutrasDespesas",
    value: ETipoDePesquisaCadis.OutrasDespesas.toString()
  }
];

export const IntegracoesTicketOpt = [
  { label: "1. Vendas - Solicitar geração arquivo de Vendas", value: "vendas" },
  {
    label: "2. Pagamentos - Solicitar geração arquivo de pagamentos",
    value: "pagamentos"
  },
  { label: "3. Download - Baixar arquivos gerados", value: "download" }
];

export const IntegracoesVROpt = [
  { value: "vendas", label: "1. Vendas - Baixar arquivos de vendas" },
  { value: "pagamento", label: "2. Pagamentos - Baixar arquivos de pagamentos" }
];

export const IntegracoesSodexoOpt = [
  { value: "vendas", label: "1. Vendas - Baixar arquivo de vendas" },
  {
    value: "pagamento",
    label: "2. Pagamentos - Solicitar geração arquivo de pagamentos"
  },
  { value: "download", label: "3. Download - Arquivos de pagamentos" }
];

export const IntegracoesPagarMeV5Opt = [
  { value: "vendas", label: "1. Vendas" },
  { value: "pagamentos", label: "2. Pagamentos" },
  { value: "saques", label: "3. Saques" }
];

export const IntegracoesMercadoPagoOpt = [
  { value: "dataVenda", label: "Data da venda" },
  { value: "dataLiquidacao", label: "Data da liquidação" }
];

export const TipoDePesquisaPagHiperOpt = [
  { label: "None", value: ETipoDePesquisaPagHiper.None.toString() },
  { label: "Criados", value: ETipoDePesquisaPagHiper.Criados.toString() },
  { label: "Pagos", value: ETipoDePesquisaPagHiper.Pagos.toString() }
];

export const IntegracoesAPIEnumOpt = [
  { label: "Boticario", value: EIntegracoesAPIEnum.Boticario },
  { label: "Zanthus", value: EIntegracoesAPIEnum.Zanthus },
  { label: "NFe", value: EIntegracoesAPIEnum.NFe },
  { label: "Stone", value: EIntegracoesAPIEnum.Stone },
  { label: "NFSe", value: EIntegracoesAPIEnum.NFSe },
  { label: "MicrovixPadrao", value: EIntegracoesAPIEnum.MicrovixPadrao },
  { label: "SAT", value: EIntegracoesAPIEnum.SAT },
  { label: "Ecletica", value: EIntegracoesAPIEnum.Ecletica },
  { label: "FXData", value: EIntegracoesAPIEnum.FXData },
  { label: "StonePadraoF360", value: EIntegracoesAPIEnum.StonePadraoF360 },
  { label: "ApiPdvTecnofit", value: EIntegracoesAPIEnum.ApiPdvTecnofit },
  { label: "TOTVSChef", value: EIntegracoesAPIEnum.TOTVSChef },
  { label: "MoozCartoes", value: EIntegracoesAPIEnum.MoozCartoes },
  { label: "MercadoPago", value: EIntegracoesAPIEnum.MercadoPago },
  { label: "PDVLoop", value: EIntegracoesAPIEnum.PDVLoop },
  { label: "Sodexo", value: EIntegracoesAPIEnum.Sodexo },
  { label: "Ticket", value: EIntegracoesAPIEnum.Ticket },
  { label: "VR", value: EIntegracoesAPIEnum.VR },
  { label: "Cielo", value: EIntegracoesAPIEnum.Cielo },
  { label: "LinxDegust", value: EIntegracoesAPIEnum.LinxDegust },
  { label: "LinxErpFranquias", value: EIntegracoesAPIEnum.LinxErpFranquias },
  { label: "LinkedGourmet", value: EIntegracoesAPIEnum.LinkedGourmet },
  { label: "PDVFollowUp", value: EIntegracoesAPIEnum.PDVFollowUp },
  { label: "PDVUPDI", value: EIntegracoesAPIEnum.PDVUPDI },
  { label: "PdvNet", value: EIntegracoesAPIEnum.PdvNet },
  { label: "CieloAPI", value: EIntegracoesAPIEnum.CieloAPI },
  { label: "PdvBling", value: EIntegracoesAPIEnum.PdvBling },
  { label: "WirecardAPI", value: EIntegracoesAPIEnum.WirecardAPI },
  { label: "PdvColibri", value: EIntegracoesAPIEnum.PdvColibri },
  { label: "OperadoraAdiq", value: EIntegracoesAPIEnum.OperadoraAdiq },
  { label: "NextSoft", value: EIntegracoesAPIEnum.NextSoft },
  { label: "PagarMe", value: EIntegracoesAPIEnum.PagarMe },
  { label: "PdvNexaasEstoka", value: EIntegracoesAPIEnum.PdvNexaasEstoka },
  { label: "PdvGilbarco", value: EIntegracoesAPIEnum.PdvGilbarco },
  { label: "IFood", value: EIntegracoesAPIEnum.IFood },
  { label: "PdvAvec", value: EIntegracoesAPIEnum.PdvAvec },
  { label: "Mvarandas", value: EIntegracoesAPIEnum.Mvarandas },
  { label: "GestaoClick", value: EIntegracoesAPIEnum.GestaoClick },
  { label: "Vindi", value: EIntegracoesAPIEnum.Vindi },
  { label: "PdvVtex", value: EIntegracoesAPIEnum.PdvVtex },
  { label: "InfinitePay", value: EIntegracoesAPIEnum.InfinitePay },
  { label: "Rede", value: EIntegracoesAPIEnum.Rede },
  { label: "Unika", value: EIntegracoesAPIEnum.Unika },
  { label: "PdvUnikaOakberry", value: EIntegracoesAPIEnum.PdvUnikaOakberry },
  { label: "PDVLegal", value: EIntegracoesAPIEnum.PDVLegal },
  { label: "PDVDataSystem", value: EIntegracoesAPIEnum.PDVDataSystem },
  { label: "PdvMitryus", value: EIntegracoesAPIEnum.PdvMitryus },
  { label: "FitCard", value: EIntegracoesAPIEnum.FitCard },
  { label: "PdvSponte", value: EIntegracoesAPIEnum.PdvSponte },
  { label: "PdvProfig", value: EIntegracoesAPIEnum.PdvProfig },
  { label: "PdvAcconNemo", value: EIntegracoesAPIEnum.PdvAcconNemo },
  { label: "PdvCPlug", value: EIntegracoesAPIEnum.PdvCPlug },
  { label: "CADIS", value: EIntegracoesAPIEnum.CADIS },
  { label: "PdvTiny", value: EIntegracoesAPIEnum.PdvTiny },
  { label: "PdvOmie", value: EIntegracoesAPIEnum.PdvOmie },
  {
    label: "PagarMe_TrackAndField",
    value: EIntegracoesAPIEnum.PagarMe_TrackAndField
  },
  { label: "PdvTerasoft", value: EIntegracoesAPIEnum.PdvTerasoft },
  { label: "VarejoOnline", value: EIntegracoesAPIEnum.VarejoOnline },
  { label: "F360_public_api", value: EIntegracoesAPIEnum.F360_public_api },
  { label: "PdvCake", value: EIntegracoesAPIEnum.PdvCake },
  { label: "PdvOXPI", value: EIntegracoesAPIEnum.PdvOXPI },
  { label: "Tray", value: EIntegracoesAPIEnum.Tray },
  { label: "EComanda", value: EIntegracoesAPIEnum.EComanda },
  { label: "PagarMe_SemSplit", value: EIntegracoesAPIEnum.PagarMe_SemSplit },
  { label: "Softcred", value: EIntegracoesAPIEnum.Softcred },
  { label: "PagHiper", value: EIntegracoesAPIEnum.PagHiper },
  { label: "Olist", value: EIntegracoesAPIEnum.Olist },
  { label: "LinxDegustV2", value: EIntegracoesAPIEnum.LinxDegustV2 },
  { label: "AmeDigital", value: EIntegracoesAPIEnum.AmeDigital },
  { label: "BusinessShop", value: EIntegracoesAPIEnum.BusinessShop },
  { label: "VarejoFacil", value: EIntegracoesAPIEnum.VarejoFacil },
  { label: "PdvAlloc", value: EIntegracoesAPIEnum.PdvAlloc },
  { label: "PdvRoverpix", value: EIntegracoesAPIEnum.PdvRoverpix },
  { label: "Api - CMV - Cigam", value: EIntegracoesAPIEnum.ApiCigamCMV }
];
